import { Injectable } from "@angular/core";
import { KEY_MFA_APP_REF } from "@common/auth_types";
import { IUser } from '../user/types';
import { UserService } from "../user/user.service";
import { nowToTimeStr } from '@common/index';

@Injectable({
    providedIn: 'root'
})
export class HyperIDAuthenticatorService
{
    private user: IUser;

    constructor(
        private readonly userService: UserService,
    )
    {
        this.userService.data.subscribe(u =>
        {
            this.user = u;
        });
    }

    public IsAppAvailable(): boolean
    {
        if (!this.user) return false;

        const mfaAppLink = this.getMfaAppLink();
        return Boolean(mfaAppLink);
    }

    public setMfaAppLink(link: string)
    {
        localStorage.setItem(KEY_MFA_APP_REF, link);
    }

    //Temporary disable automatically app opening
    public async tryOpenApp(hyperIdAuthenticatorAppUrl?: string): Promise<boolean>
    {
        return false;
        // if (!hyperIdAuthenticatorAppUrl) return false;

        // try
        // {
        //     console.log(`${ nowToTimeStr() } >> tryOpenApp: ${ hyperIdAuthenticatorAppUrl }`);
        //     window.open(hyperIdAuthenticatorAppUrl, '_blank');
        //     return true;
        // }
        // catch (err)
        // {
        //     console.error(err);
        //     return false;
        // }
    }

    private getMfaAppLink(): string
    {
        const mfaAppLinkFromStorage = localStorage.getItem(KEY_MFA_APP_REF);
        return mfaAppLinkFromStorage;
    }
}
